<script>
import {  common } from '@/mixins/common';
import {
    GetApiActionWithAuthorizationOnly,
    PostApiWithAuthorizationAction,
    GetApiActionWithAuthorization
} from '../../../helpers/apiActions';
import ViewProductGallery from "@/components/drawers/product/viewProductGallery";
import AddNewAlbumDrawerContent from "@/components/drawers/product/AddNewAlbumDrawerContent.vue";
import VLazyImage from "v-lazy-image/v2";
import { isMobile, isTablet } from "mobile-device-detect";

export default {
  name: 'AlbumList',
  components: {
    VLazyImage,
    ViewProductGallery,
    AddNewAlbumDrawerContent
  },
  props: {},
  data() {
    return {
        tableData: [],
        viewProductGalleryDrawer: false,
        displayAlbumPopup: false,
        selectedAlbum: { id: 0, title: '', AuctionAttachments: [] },
        pagination: {
            page_size: 50,
            total: 1,
            page: 1
        },
        users: [],
        productPictures: [],
        tabCount: 0,
        columns: [
            {
                key: "album_view",
                value: 'Album Photos',
                sortable: false,
            },
            {
                key: "album_title",
                value: 'Album Name',
                sortable: false,
            },
            {
                key: "actions",
                value: 'Actions',
                sortable: false,
                center: true
            }
        ],
    }
  },
  mixins: [
    common
  ],
  methods: {
    loadAlbumEdit(id) {
        let _vm = this;
        GetApiActionWithAuthorization("admin/products/live-show/get-album/" + id)
          .then((res) => {
            if (res.status == "success") {
              _vm.$set(_vm, 'selectedAlbum', res.data)
              //
              _vm.displayAlbumPopup = true;
            }
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true,
            });
          });
    },
    loadProductPictures(id, length = 0) {
      if (length > 0) {
        let _vm = this;
        GetApiActionWithAuthorization("admin/products/live-show/get-album-pictures/" + id)
          .then((res) => {
            if (res.status == "success") {
              _vm.productPictures = res.data;
              //
              _vm.viewProductGalleryDrawer = true;
            }
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
            _vm.$toast.error(error.message, {
              position: "top-right",
              timeout: 1000,
              closeOnClick: true,
            });
          });
      }
    },
    loadPageData () {
        let _vm = this
        return GetApiActionWithAuthorizationOnly("admin/products/live-show/get-albums").then(res => {
            _vm.tabCount = res.count
            _vm.users = res.users
            _vm.tableData = res.data
        });
    },
    updateCurrentPage(page) {
        this.loadPageData({ page })
        let url = window.location.href.split(/[?#]/)[0];    
        url += (url.indexOf('?') > -1) ? "&" : "?";
        url += "page=" + page
        window.history.replaceState({}, "Cybershop v2", url);
    },
    deleteAlbum(id) {
        let _vm = this
        if (confirm('Are you sure that you want to remove this Album ?')) {
            PostApiWithAuthorizationAction("admin/products/live-show/delete-album/" + id).then(() => {
                _vm.tableData = _vm.tableData.filter(v=>v.id!=id)
            })
        }
    }
  },
  computed: {
    pictureDrawerSize() {
      return isMobile ? "100%" : isTablet ? "60%" : "35%";
    },
  },
  mounted () {
    let _vm = this
    _vm.loadPageData()
  }
}
</script>
<template>
    <div class="setting-general__content">
        <!-- Picture Viewer Drawer -->
        <el-drawer
            title="Product Pictures"
            :visible.sync="viewProductGalleryDrawer"
            :close-on-press-escape="false"
            :size="pictureDrawerSize"
            :with-header="true"
            :wrapperClosable="false"
            :append-to-body="true"
            custom-class="common-drawer picture-gallery"
            >
            <ViewProductGallery :pictures="productPictures" />
        </el-drawer>
        <el-drawer
            ref="editAlbumDrawer"
            :title="'Edit Album #' + selectedAlbum.id"
            :visible.sync="displayAlbumPopup"
            :close-on-press-escape="false"
            :with-header="true"
            :wrapperClosable="false"
            :size="mediumDrawerSize"
            :append-to-body="true"
            :destroy-on-close="true"
            custom-class="common-drawer demo-drawer"
            >
            <AddNewAlbumDrawerContent :album="selectedAlbum"/>
        </el-drawer>
        <div class="table-responsive">
            <table
                role="table"
                aria-busy="false"
                aria-colcount="10"
                class="table b-table"
                >
                    <thead
                    role="rowgroup"
                    class=""
                    style="background-color: #74788d; color: white"
                    >
                    <tr role="row" class="">
                        <th
                        role="columnheader"
                        scope="col"
                        aria-colindex="1"
                        :class="[
                            column.center ? 'text-center': '',
                            'px-4'
                        ]"
                        v-for="column in columns"
                        :key="column.key"
                        >
                        <div>{{ column.value }}</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody role="rowgroup">
                    <tr
                        role="row"
                        aria-rowindex="1"
                        class=""
                        v-for="(data) in tableData"
                        :key="data.id"
                    >
                        <td
                            aria-colindex="1"
                            role="cell"
                            style="vertical-align: middle"
                            class="col-sm">
                            <div @click="loadProductPictures(data.id, data.AuctionAttachments.length)">
                                <v-lazy-image
                                    class="d-block w-100 img-thumbnail"
                                    :src="data.AuctionAttachments[0].thumbnailUrl"
                                    v-bind:src-placeholder="require('@/assets/images/image-lazy-loading.gif')"
                                    v-if="data.AuctionAttachments.length > 0"
                                />
                                <span v-else>No Picture available</span>
                            </div>
                        </td>
                        <td
                            aria-colindex="1"
                            role="cell"
                            style="font-size: 14px;text-transform: capitalize;vertical-align: middle"
                            class="col-sm">
                            <b>{{ data.title }}</b>
                        </td>
                        <td
                            aria-colindex="2"
                            role="cell"
                            :class="['text-center', 'px-0', 'col-sm']">
                            <div class="mb-1">
                                <a
                                    href="javascript:;"
                                    class="btn btn-primary btn-sm"
                                    @click="loadAlbumEdit(data.id)"
                                    :disabled="data.printing"
                                    >
                                    <i class="fas fa-edit"></i> Edit
                                </a>&nbsp;&nbsp;
                                <a
                                    href="javascript:;"
                                    class="btn btn-danger btn-sm"
                                    @click="deleteAlbum(data.id)"
                                    >
                                    <i class="fas fa-trash"></i> Delete
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="pagination.total"
                :page-size="pagination.page_size"
                @current-change="updateCurrentPage"
                :current-page.sync="pagination.page"
                v-if="tableData.length > 0">
            </el-pagination>
        </div>
    </div>
</template>

<style scoped>
.img-thumbnail {
    max-width: 90px !important;
    max-height: 90px !important;
    cursor: pointer;
}
.b-table {
    background-color: rgba(0, 0, 0, 0.05);
    border: 5px solid #5b5f70;
}
.b-table td {
    padding-top: 6px;
    padding-bottom: 3px;
    vertical-align: middle
}
@media (min-width: 768px) {
    .b-table {
        width: 40%;
    }
}
@media (min-width: 1025px) and (max-width: 1280px) {
    .b-table {
        width: 50%;
    }
}
</style>